import axiosInstance from '../../../config/axiosInstance';
const handleSubmitForCheckbox = async (payload, checkboxState, redirectCallback, redirectAssignModules) => {
    // Perform validation if needed
    try {
        const UserID = localStorage.getItem("UserID");
      //  const formData = { checkboxState, JobID: JobID, UserID: UserID };
        const response = await axiosInstance.post(`/Job/CreateIssueAsset`, payload);
        return response.data.message;
    } catch (error) {
        console.error('Error saving checkbox data:', error);
    }
};
export default handleSubmitForCheckbox; 